import React, { Fragment } from 'react';
// reactstrap components
import { NavItem, NavLink, Nav, Container, Row, Col } from 'reactstrap';
document.body.classList.add('bg-default');

const AuthFooter = (props) => (
	<Fragment>
		<footer className='py-5'>
			<Container>
				<Row className='align-items-center justify-content-xl-between'>
					<Col xl='6'>
						<div className='copyright text-center text-xl-left text-muted'>
							© 2020
							<a
								className='font-weight-bold ml-1'
								href='https://www.creative-tim.com?ref=adr-auth-footer'>
								Mt.Dews
							</a>
						</div>
					</Col>
					<Col xl='6'>
						<Nav className='nav-footer justify-content-center justify-content-xl-end'>
							<NavItem>
								<NavLink href='https://www.creative-tim.com?ref=adr-auth-footer'>
									Creative Tim
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink href='https://www.creative-tim.com?ref=adr-auth-footer'>
									About Us
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink href='https://www.creative-tim.com?ref=adr-auth-footer'>
									Developers
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink href='https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md?ref=adr-auth-footer'>
									MIT License
								</NavLink>
							</NavItem>
						</Nav>
					</Col>
				</Row>
			</Container>
		</footer>
	</Fragment>
);

export default AuthFooter;
